import { useTranslation } from "react-i18next";
import FaqItem from "../../items/FaqItem";

const Faq = () => {
  const { t } = useTranslation();

  const faqsData = [
    {
      faqTitle: t("When do I Get Paid?"),
      faqDescription: t(
        "You can register by visiting our official website and filling out the registration form."
      ),
      gradient: "from-[#361280] via-[#7037F0] to-[#4A20AC]",
    },
    {
      faqTitle: t("Can I Manage Promoters?"),
      faqDescription: t(
        "<p>Absolutely! Add unlimited</p><p>promoters, set commissions or discount codes, and track performance</p>"
      ),
      gradient: "from-[#CE3894] via-[#CF3995] to-[#751752]",
    },
    {
      faqTitle: t("How Do You Help Me Sell More Tickets?"),
      faqDescription: t(
        "Our platform not only manages your sales but also connects you with a dance-focused audience and marketing tools built to drive growth."
      ),
      gradient: "from-[#E57A34] via-[#BC2C25] to-[#E53449]",
    },
  ];

  return (
    <section className="relative py-24 bg-magnolia">
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto px-6">
        <h2 className="text-deep-purple text-3xl 2xl:text-4xl font-bold mb-12">
          FAQ Highlights
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 2xl:gap-12">
          {faqsData.map((item, index) => (
            <FaqItem key={index} data={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
